import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui";
import { ClientInfo as ClientInfoType } from "../../../api/Client";
import { Building2 } from "lucide-react";

interface ClientInfoProps {
  Client: ClientInfoType | null;
}

/**
 * Component to display Client information
 */
export const ClientInfo: React.FC<ClientInfoProps> = ({ Client }) => {
  if (!Client) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Client Information</CardTitle>
          <CardDescription>No Client information available</CardDescription>
        </CardHeader>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Building2 className="h-5 w-5" />
          Client Information
        </CardTitle>
        <CardDescription>Details about your organization</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {Client.name ? (
            <div>
              <h3 className="text-sm font-medium text-muted-foreground">
                Client Name
              </h3>
              <p className="text-xl font-semibold">{Client.name}</p>
            </div>
          ) : (
            <div>
              <h3 className="text-sm font-medium text-muted-foreground">
                Client ID
              </h3>
              <p className="text-xl font-semibold">{Client.clientId}</p>
            </div>
          )}

          <div>
            <h3 className="text-sm font-medium text-muted-foreground">
              Team Size
            </h3>
            <p className="text-xl font-semibold">
              {Client.members.length} members
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
